import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import MasterViewController from "../../redux/actions/masterApiActions";
import "../../styles/styles.css";
import "../../styles/layout.css";

function RolesFormModal({ show, handleClose, initialData = null }) {
  const dispatch = useDispatch();
  const { addRole, updateRole } = MasterViewController();
  const { roles } = useSelector((state) => state.master);
  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    role_name: "",
  });

  useEffect(() => {
    if (show && initialData) {
      setInitialValues({
        role_name: initialData.role_name || "",
      });
    } else if (show && !initialData) {
      setInitialValues({
        role_name: "",
      });
    }
  }, [show, initialData]);

  const handleSubmit = (values, { resetForm }) => {
    const action = isEdit
      ? updateRole(initialData.id, values)
      : addRole(values);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
      })
      .catch((error) => {
        console.error("Error submitting role form:", error);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center">
            {isEdit ? "Edit Role" : "Add Role"}
            </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {() => (
            <Form>
              <div className="mb-2">
                <label>Role Name</label>
                <Field name="role_name" className="form-control" />
              </div>
              <Button type="submit" variant="primary" className="mt-3">
                {isEdit ? "Update" : "Submit"}
              </Button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default RolesFormModal;
